import {
	type TypeaheadCursorIndexes,
	type TypeaheadDataSection,
	type TypeaheadProductsSection,
	type TypeaheadSection,
	type TypeaheadSectionDimensions,
	type TypeaheadState,
	type TypeaheadTermsSection
} from './search-bar-reducer.types';

const TERMS_SECTIONS: Record<TypeaheadTermsSection, boolean> = { recentTerms: true, recentTermsRemove: true, suggestedTerms: true };
const PRODUCTS_SECTIONS: Record<TypeaheadProductsSection, boolean> = { suggestedProducts: true };
const SUGGESTIONS_SECTIONS: Partial<Record<TypeaheadDataSection, boolean>> = { suggestedTerms: true, suggestedProducts: true };

export function cursorIndexProp(section: TypeaheadDataSection): keyof TypeaheadCursorIndexes {
	return `${section}CursorIndex`;
}

export function isTermsSection(section: TypeaheadSection): section is TypeaheadTermsSection {
	return TERMS_SECTIONS[section];
}

export function isProductsSection(section: TypeaheadSection): section is TypeaheadProductsSection {
	return PRODUCTS_SECTIONS[section];
}

export function isDataSection(section: TypeaheadSection): section is TypeaheadDataSection {
	return isTermsSection(section) || isProductsSection(section);
}

export function isSuggestionsSection(section: TypeaheadSection): boolean {
	return SUGGESTIONS_SECTIONS[section];
}

export function getCursorIndex(state: TypeaheadState, section: TypeaheadDataSection): number {
	return state[cursorIndexProp(section)];
}

export function getCursorIndexes(state: TypeaheadState, ...sections: TypeaheadSection[]): Partial<TypeaheadCursorIndexes> {
	return sections
		.filter(isDataSection)
		.map(cursorIndexProp)
		.reduce((result, prop) => {
			result[prop] = state[prop];
			return result;
		}, {});
}

export function getSectionDimensions(state: TypeaheadState, section: TypeaheadSection): TypeaheadSectionDimensions {
	if (!isDataSection(section)) {
		return { count: 0, rows: 0, columns: 1 };
	}
	const count = state[section].length;
	const columns = state[`${section}Columns`] ?? 1;
	const rows = Math.ceil(count / columns);
	return { count, rows, columns };
}
